app.components = {
	// COMMON --------------------------------------------
	// Configs + Constants
	TIMERS: '',
	DATA: '',
	AJAX: '',

	// MAIN FUNCTIONS ------------------------------------
	init: function () {
		console.warn('-- app.js - components - init -- ');
		this.setupLayout();
		this.setupEvents();

		this.icons.check();
	},

	setupEvents: function () {},
	setupLayout: function () {},


	// OTHER FUNCTIONS -----------------------------------
	getTemplate: function (id) {
		if (!app.helpers.isEmpty(id)) {
			var $clone = $($body.find('template[data-tpl-id="' + id + '"]').html()).clone();
			return $.when(app.components.icons.check($clone));
		}
	},

	lazyLoad: function(){
		if($body.find('img.js-lazyLoad').length > 0){
			new LazyLoad({
				elements_selector: '.js-lazyLoad'
			});
		}
	},

	icons: {
		list: [],
		endpointCall: function(id){
			var getURI = app.assetsURI + 'images/icons/'+id+'.svg';

			return $.ajax({
				url: getURI,
				dataType: 'html',
				type: 'GET'
			});
		},
		check: function($wrapper){
			$wrapper = $wrapper || $body;

			var _this = app.components.icons,
				$icons = $wrapper.find('.js-placeIcon:not(.icon-is-loaded):not(.is-waiting)');

			if($icons.length > 0){
				$icons.addClass('is-waiting');

				$icons.each(function(){
					var $el = $(this),
						id = $el.data('id');

					if(!app.helpers.isEmpty(id) && id !== 'icon-') {

						var check = localStorage.getItem(id);
						if(app.helpers.isEmpty(check)){
							_this.endpointCall(id)
								.fail(function(xhr, status, error){
									return true;
								})
								.done(function(svg){
									localStorage.setItem(id, svg);
									_this.placeIcon(id, $el, $wrapper);
								});

						}
						else {
							_this.placeIcon(id, $el);
						}
					}
				});
			}
		},

		placeIcon: function(id, $el, $loop){
			var svg = localStorage.getItem(id);

			if(!app.helpers.isEmpty(svg) && !$el.hasClass('icon-is-loaded') && $el.hasClass('is-waiting')){
				$el
					.removeClass('is-waiting')
					.addClass('icon-is-loaded')
					.html(svg);
			}
			else{
				$el.removeClass('is-waiting');
				app.components.icons.check($loop);
			}
		}
	},
};
